"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Image = _interopRequireDefault(require("../Image"));

var _Container = _interopRequireDefault(require("../Container"));

var _constant = require("../constant");

var _AdsPlaceholder = _interopRequireDefault(require("./AdsPlaceholder.proptypes"));

var _constant2 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var AdsPlaceHolderWrapper = _styledComponents.default.div.withConfig({
  displayName: "AdsPlaceholder__AdsPlaceHolderWrapper",
  componentId: "sc-15qx27c-0"
})([""]);

var PrimeAdsWrapper = _styledComponents.default.div.withConfig({
  displayName: "AdsPlaceholder__PrimeAdsWrapper",
  componentId: "sc-15qx27c-1"
})(["#prime-ads-placeholder{margin:0 auto;}"]);

var StandardAdsWrapper = _styledComponents.default.div.withConfig({
  displayName: "AdsPlaceholder__StandardAdsWrapper",
  componentId: "sc-15qx27c-2"
})(function (_ref) {
  var theme = _ref.theme,
      space = _ref.space,
      isMobile = _ref.isMobile;
  return "\n        text-align: center;\n        #standard-ads-placeholder-wrapper {\n            display: inline-block;\n\n            & > div {\n                box-shadow: none;\n            }\n        }\n\n        ".concat(isMobile ? "\n                [data-standardads='true']:not(:last-child) {\n                    margin-bottom: ".concat(theme.space[space], ";\n                }\n            ") : '', "\n    ");
});

var AdsPlaceholder = function AdsPlaceholder(props) {
  var type = props.type,
      primeConfig = props.primeConfig,
      standardConfig = props.standardConfig,
      viewport = props.viewport,
      accessible = props.accessible,
      theme = props.theme,
      customProperties = props.customProperties,
      adsToDisplay = props.adsToDisplay,
      placeHolderBackground = props.placeHolderBackground,
      displayDefaultAdStandard = props.displayDefaultAdStandard,
      displayDefaultAdPrime = props.displayDefaultAdPrime;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var primeAds = function primeAds() {
    var _primeConfig$dimensio; // eslint-disable-next-line react/prop-types


    var desktopImageUrl = primeConfig.desktopImageUrl,
        mobileImageUrl = primeConfig.mobileImageUrl,
        alt = primeConfig.alt;
    var imageSrc = displayDefaultAdPrime ? desktopImageUrl : ''; // eslint-disable-next-line react/prop-types

    var dimensions = (primeConfig === null || primeConfig === void 0 || (_primeConfig$dimensio = primeConfig.dimensions) === null || _primeConfig$dimensio === void 0 ? void 0 : _primeConfig$dimensio.desktop) || _constant2.DEFAULT_PRIMECONFIG.dimensions.desktop;

    if (viewport === _constant.DEVICE_TYPE.MOBILE) {
      var _primeConfig$dimensio2;

      imageSrc = displayDefaultAdPrime ? mobileImageUrl : ''; // eslint-disable-next-line react/prop-types

      dimensions = (primeConfig === null || primeConfig === void 0 || (_primeConfig$dimensio2 = primeConfig.dimensions) === null || _primeConfig$dimensio2 === void 0 ? void 0 : _primeConfig$dimensio2.mobile) || _constant2.DEFAULT_PRIMECONFIG.dimensions.mobile;
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, imageSrc && /*#__PURE__*/_react.default.createElement(PrimeAdsWrapper, null, /*#__PURE__*/_react.default.createElement(_Image.default, (0, _extends2.default)({}, placeHolderBackground && {
      placeHolderBackground: {
        placeHolderBackground: placeHolderBackground
      }
    }, {
      src: imageSrc,
      height: dimensions.height,
      width: dimensions.width,
      theme: theme,
      customProperties: {
        id: 'prime-ads-placeholder'
      },
      accessible: accessible,
      alt: alt
    }))));
  };

  var standardAds = function standardAds() {
    var _finalImages; // eslint-disable-next-line react/prop-types


    var desktopImageUrl = standardConfig.desktopImageUrl,
        mobileImageUrl = standardConfig.mobileImageUrl,
        space = standardConfig.space,
        alt = standardConfig.alt;
    var imageSrcs = displayDefaultAdStandard ? (0, _toConsumableArray2.default)(desktopImageUrl) : [];
    var dimensions = _constant2.DEFAULT_STANDARDCONFIG.dimensions.desktop;
    var isMobile = viewport === _constant.DEVICE_TYPE.MOBILE;

    if (isMobile) {
      imageSrcs = displayDefaultAdStandard ? (0, _toConsumableArray2.default)(mobileImageUrl) : [];
      dimensions = _constant2.DEFAULT_STANDARDCONFIG.dimensions.mobile;
    }

    var finalImages = imageSrcs;

    if (adsToDisplay !== undefined && adsToDisplay !== null && imageSrcs[adsToDisplay]) {
      finalImages = imageSrcs.splice(adsToDisplay, 1);
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ((_finalImages = finalImages) === null || _finalImages === void 0 ? void 0 : _finalImages.length) > 0 && /*#__PURE__*/_react.default.createElement(StandardAdsWrapper, {
      isMobile: isMobile,
      space: space
    }, /*#__PURE__*/_react.default.createElement(_Container.default, {
      isSideBySide: !isMobile,
      gapChildren: space,
      customProperties: {
        id: 'standard-ads-placeholder-wrapper'
      }
    }, // eslint-disable-next-line react/prop-types
    finalImages.map(function (imgSrc, idx) {
      return /*#__PURE__*/_react.default.createElement(_Image.default, {
        key: imgSrc,
        src: imgSrc,
        alt: alt[idx] || '',
        height: dimensions.height,
        width: dimensions.width,
        theme: theme,
        customProperties: {
          'data-standardads': true
        },
        accessible: accessible
      });
    }))));
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(AdsPlaceHolderWrapper, (0, _extends2.default)({
      key: "".concat(type, "-").concat(viewport)
    }, customProperties), type === _constant2.ADS_PLACEHOLDER_TYPE.STANDARD ? standardAds() : primeAds());
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

AdsPlaceholder.propTypes = _AdsPlaceholder.default.PropTypes;
AdsPlaceholder.defaultProps = _AdsPlaceholder.default.DefaultProps;
var _default = AdsPlaceholder;
exports.default = _default;